import React from 'react';
import { useParams } from 'react-router-dom';
import UsersList from '../components/users/UsersList';

const UsersPage = () => {
  const { companySlug } = useParams();

  return (
    <div className="users">
      <div className="users__content cts-container">
        <UsersList />
      </div>
    </div>
  );
};

export default UsersPage;